import React from "react";
import { NotificationProps } from "@/features/notification/Notification";
import { PortalDrawer } from "./PortalDrawer";
import { ProductSelectorPage } from "./PortalDrawer/pages/ProductSelectorPage";
import { useAddNewBoxItem, AddBoxItemParams } from "./AccountContext";
import { Address, BoxItem } from "./types";
import { track } from "@/helpers/googleAnalytics";

export interface AddProductDrawerProps {
  open: boolean;
  onExit: () => void;
  notify: (notification: NotificationProps) => void;
  selectedBoxItem?: BoxItem;
  initialFilter?: string;
  sourceModule?: string;
}

const AddProductDrawer = ({
  open,
  onExit,
  selectedBoxItem,
  notify,
  initialFilter,
  sourceModule,
}: AddProductDrawerProps) => {
  const addItemMutator = useAddNewBoxItem();

  const onChange = (
    params: AddBoxItemParams,
    address: Address,
    nextChargeDate: Date
  ): void => {
    const addItemParams = {
      params,
      address,
      nextChargeDate,
      sourceModule: sourceModule ?? "portal_add_product_drawer",
    };

    addItemMutator.mutate(addItemParams, {
      onSuccess: (data) => {
        notify({
          title: "Product Added",
          message: `You have added ${params.product.title}`,
        });
        track({
          name: "Portal Add Item",
          item: data,
          sourceModule: addItemParams.sourceModule,
        });
        onExit();
      },
      onError: () => {
        notify({
          title: "Error",
          message: `An error occurred. Please try again.`,
          severity: "error",
        });
      },
    });
  };

  return (
    <PortalDrawer
      open={open}
      onExit={onExit}
      notify={notify}
      goToFirstPage={() => {}}
      title="Add Product"
      contents={(nav) =>
        selectedBoxItem ? (
          <ProductSelectorPage
            {...nav}
            onChange={(params) =>
              onChange(
                params,
                selectedBoxItem.address,
                selectedBoxItem.rechargeItem.nextChargeDate
              )
            }
            nextChargeDate={selectedBoxItem.rechargeItem.nextChargeDate}
            displayMode="all"
            cadence={selectedBoxItem.rechargeItem.cadence ?? undefined}
            canUpdateInterval={true}
            initialFilter={initialFilter}
          />
        ) : null
      }
    />
  );
};

export { AddProductDrawer };
